import { Phone, MessageCircle, Car } from "lucide-react";
import { trackConversion } from "@/lib/gtag";

export function StickyMobileBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-border/60 bg-background/95 backdrop-blur lg:hidden">
      <div className="mx-auto grid max-w-[600px] grid-cols-3 gap-2 px-3 py-2.5">
        <a
          href="tel:0493100265"
          onClick={() => trackConversion("phoneCall")}
          className="flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-primary text-sm font-semibold text-primary-foreground"
        >
          <Phone className="h-4 w-4" />
          Call
        </a>
        <a
          href="https://wa.me/61493100265?text=Hi%20SE%20Premium%20Cabs%2C%20I%27d%20like%20to%20book%20a%20ride"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackConversion("whatsapp")}
          className="flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-primary text-sm font-semibold text-primary"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp
        </a>
        <a
          href="#book"
          className="flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-border text-sm font-semibold text-foreground"
        >
          <Car className="h-4 w-4" />
          Book
        </a>
      </div>
    </div>
  );
}